// Professional brief niches with discovery questions
export const NICHES = [
  {
    slug: "web-design",
    name: "Web Design",
    icon: "Globe",
    accent: "from-violet-500 to-indigo-500",
    questions: [
      "What is the primary goal of your website? (e.g., generate leads, sell products, showcase portfolio)",
      "Who is your target audience? Describe their demographics and pain points.",
      "List 3-5 competitor or inspiration websites you admire and what you like about them.",
      "What is your brand color palette and do you have an existing logo or style guide?",
      "How many pages do you need and what content sections must each include?",
      "Will you need any custom functionality? (booking, payments, member login, blog, multi-language)",
      "What is the launch deadline and your total budget range for this project?",
      "Who will manage and update the site after launch?",
    ],
  },
  {
    slug: "seo",
    name: "SEO",
    icon: "Search",
    accent: "from-emerald-500 to-teal-500",
    questions: [
      "What is your current website URL and how long has it been live?",
      "What are your top 5 target keywords or services you want to rank for?",
      "Which geographic locations are most important for your business?",
      "Who are your main organic search competitors?",
      "Do you have Google Analytics, Search Console and any existing SEO tools set up?",
      "What is your monthly content publishing capacity?",
      "Have you been penalized or run any prior SEO campaigns? Share results if available.",
      "What is your timeline expectation for measurable ranking improvements?",
    ],
  },
  {
    slug: "shopify",
    name: "Shopify Store",
    icon: "ShoppingBag",
    accent: "from-green-500 to-emerald-600",
    questions: [
      "How many products will you launch with and what categories do they fall into?",
      "Do you have product photography, descriptions and inventory ready?",
      "Which payment gateways and shipping carriers do you need integrated?",
      "Will you sell internationally? List target countries and currencies.",
      "Do you need any specific apps? (subscriptions, reviews, upsells, loyalty)",
      "What is your branding direction and do you have a logo, fonts, colors?",
      "Do you have an existing customer list or are you starting from scratch?",
      "When is your planned launch date and what is your marketing plan?",
    ],
  },
  {
    slug: "social-media",
    name: "Social Media",
    icon: "Share2",
    accent: "from-pink-500 to-rose-500",
    questions: [
      "Which platforms do you want to focus on? (Instagram, LinkedIn, X, TikTok, YouTube)",
      "What is your brand voice and tone? Casual, professional, witty, inspirational?",
      "How many posts per week do you want across each platform?",
      "Will you provide raw photos/videos or do we need to create content from scratch?",
      "Who are 3-5 brands or creators whose style you admire?",
      "Do you have specific campaigns, launches or seasonal pushes coming up?",
      "What KPIs matter most? (followers, engagement, leads, sales)",
      "Will you be running paid ads alongside organic content?",
    ],
  },
  {
    slug: "video-editing",
    name: "Video Editing",
    icon: "Video",
    accent: "from-orange-500 to-red-500",
    questions: [
      "What type of videos do you need edited? (YouTube, reels, podcasts, ads, tutorials)",
      "What is the final length and how much raw footage will you provide?",
      "Do you have brand assets - intros, outros, lower thirds, music library?",
      "What is the editing style? (fast cuts, cinematic, talking head, motion graphics)",
      "Will captions, sound design and color grading be required?",
      "Which platforms is the video for and what aspect ratios are needed?",
      "How fast is your typical turnaround expectation?",
      "How many revisions do you expect per video?",
    ],
  },
  {
    slug: "doctors",
    name: "Doctors / Healthcare",
    icon: "Stethoscope",
    accent: "from-sky-500 to-blue-600",
    questions: [
      "What is your medical specialty and primary services offered?",
      "What is your clinic name, address and operating hours?",
      "Do you need online appointment booking? Which calendar system do you use?",
      "What patient testimonials or case studies can you share publicly?",
      "Do you need integration with any practice management software?",
      "What languages should your website support?",
      "Are there compliance requirements? (HIPAA in US, telemedicine policies)",
      "What patient acquisition channels work best for you currently?",
    ],
  },
  {
    slug: "dentists",
    name: "Dentists",
    icon: "Smile",
    accent: "from-cyan-500 to-sky-500",
    questions: [
      "What dental services do you offer? (general, cosmetic, orthodontics, implants)",
      "Do you offer financing, insurance acceptance or in-house plans?",
      "How many locations do you operate?",
      "Do you want before/after galleries on the website?",
      "Is online appointment booking needed and which system do you use?",
      "What is your unique differentiator vs. nearby dental practices?",
      "Do you run any patient referral or loyalty programs?",
      "What patient education content should be included?",
    ],
  },
  {
    slug: "restaurants",
    name: "Restaurants",
    icon: "Utensils",
    accent: "from-amber-500 to-orange-500",
    questions: [
      "What is your cuisine type and signature dishes?",
      "Do you have multiple locations and what are their hours?",
      "Do you need online ordering, table reservations or both?",
      "Will you integrate with delivery platforms? (UberEats, Zomato, DoorDash)",
      "Do you have high-quality food photography ready?",
      "Will you publish your menu online with prices?",
      "Do you have a loyalty program or special events to feature?",
      "Who is your target customer? (families, date night, business lunch, tourists)",
    ],
  },
  {
    slug: "real-estate",
    name: "Real Estate",
    icon: "Home",
    accent: "from-lime-500 to-green-500",
    questions: [
      "Do you focus on residential, commercial, rentals or all of the above?",
      "What geographic areas do you serve?",
      "Do you need MLS / IDX integration for live listings?",
      "How will agent profiles and contact information be presented?",
      "Do you need lead capture forms, mortgage calculators or property alerts?",
      "What is your typical property price range?",
      "Do you do virtual tours or video walkthroughs?",
      "How do you currently generate leads and what works best?",
    ],
  },
  {
    slug: "coaching",
    name: "Coaching",
    icon: "Award",
    accent: "from-purple-500 to-violet-500",
    questions: [
      "What is your coaching niche? (life, business, fitness, mindset, career)",
      "What is your signature program or methodology?",
      "Do you offer 1:1 coaching, group programs, courses or all?",
      "What is your price point and how do you handle payments?",
      "Do you have testimonials, case studies or transformation stories?",
      "Will you need a course platform, community area or members-only content?",
      "What is your content marketing approach? (podcast, YouTube, newsletter)",
      "What is the typical journey a client takes from discovery to working with you?",
    ],
  },
  {
    slug: "salon-spa",
    name: "Salon & Spa",
    icon: "Scissors",
    accent: "from-rose-500 to-pink-600",
    questions: [
      "What services do you offer? (hair, nails, facials, massage, makeup)",
      "Do you need online booking with stylist selection?",
      "Will you sell retail products online?",
      "Do you have a loyalty program or memberships?",
      "How many stylists/staff will have profiles on the site?",
      "What is your brand aesthetic? (luxury, minimalist, trendy, organic)",
      "Will gift cards be offered online?",
      "Do you run any seasonal promos or packages?",
    ],
  },
  {
    slug: "gym-fitness",
    name: "Gym & Fitness",
    icon: "Dumbbell",
    accent: "from-red-500 to-orange-600",
    questions: [
      "What type of facility is it? (gym, boutique studio, CrossFit, yoga, online)",
      "Do you offer classes, personal training, memberships or all?",
      "Do you need class scheduling and membership management?",
      "What payment models will you use? (monthly, annual, drop-in, packages)",
      "Will you have a member portal, app or community features?",
      "Do you offer corporate or partnership memberships?",
      "What success stories or transformations can you showcase?",
      "Do you sell merchandise or supplements?",
    ],
  },
  {
    slug: "travel",
    name: "Travel & Tourism",
    icon: "Plane",
    accent: "from-blue-500 to-cyan-500",
    questions: [
      "What type of travel do you specialize in? (luxury, adventure, group, business)",
      "Do you sell packages, custom itineraries, or both?",
      "Which destinations do you focus on?",
      "Do you need booking integration with any GDS or supplier system?",
      "How will customer reviews and trip galleries be presented?",
      "What is your average trip price range?",
      "Do you have an existing customer database to migrate?",
      "How do you handle inquiries and follow-ups currently?",
    ],
  },
  {
    slug: "graphic-design",
    name: "Graphic Design",
    icon: "Palette",
    accent: "from-fuchsia-500 to-purple-500",
    questions: [
      "What deliverables are in scope? (logo, brand identity, print, packaging, illustrations)",
      "How many initial concepts and revisions are included?",
      "Do you have a brand brief, mood board or competitor references?",
      "What file formats do you need on delivery? (AI, PDF, PNG, SVG)",
      "Will source files and full ownership be transferred?",
      "Are there any specific design styles or trends you want to follow or avoid?",
      "What is the project timeline and any hard deadlines?",
      "Will the work be used for print, digital or both?",
    ],
  },
  {
    slug: "app-dev",
    name: "App Development",
    icon: "Smartphone",
    accent: "from-indigo-500 to-blue-500",
    questions: [
      "Is this a native (iOS/Android), cross-platform (Flutter/React Native) or web app?",
      "What are the must-have features for v1 vs. future versions?",
      "Do you have wireframes, designs or just an idea so far?",
      "Will you need a backend, database, authentication and admin panel?",
      "Are there any third-party integrations required? (Stripe, maps, push, analytics)",
      "What is your projected user base and scale expectations?",
      "Do you need app store submission and ongoing maintenance?",
      "What is the launch timeline and total budget?",
    ],
  },
  {
    slug: "consultants",
    name: "Consultants",
    icon: "Briefcase",
    accent: "from-slate-500 to-zinc-600",
    questions: [
      "What is your consulting domain and primary services?",
      "Who is your ideal client? (industry, size, role)",
      "What is your engagement model? (project, retainer, hourly, value-based)",
      "What proof of expertise will you showcase? (case studies, testimonials, publications)",
      "Will you offer free discovery calls and how will they be scheduled?",
      "Do you publish thought leadership content?",
      "What outcomes do your clients typically experience?",
      "How do most of your clients currently find you?",
    ],
  },
  {
    slug: "legal",
    name: "Legal Services",
    icon: "Scale",
    accent: "from-stone-500 to-neutral-600",
    questions: [
      "What practice areas do you specialize in?",
      "How is your firm structured? (solo, partnership, multi-attorney)",
      "Do you offer free consultations and how should they be booked?",
      "What jurisdictions are you licensed to practice in?",
      "Do you need secure client intake forms or document upload?",
      "How will attorney profiles and credentials be presented?",
      "Do you handle cases on contingency, hourly, flat fee or mixed?",
      "Are there compliance restrictions on marketing in your region?",
    ],
  },
    {
    slug: "content-writing",
    name: "Content Writing",
    icon: "PenTool",
    accent: "from-blue-500 to-indigo-500",
    questions: [
      "What type of content do you need? (blogs, website copy, emails, social posts, scripts)",
      "Who is your target audience?",
      "What tone of voice should the content use? (professional, friendly, persuasive, luxury)",
      "Do you have brand guidelines or previous content examples?",
      "How many pieces or words are required?",
      "Do you need SEO keyword research included?",
      "What references or competitor content should we review?",
      "What is your deadline and approval process?",
    ],
  },
  {
    slug: "ui-ux-design",
    name: "UI/UX Design",
    icon: "Layout",
    accent: "from-violet-500 to-purple-600",
    questions: [
      "What product or platform needs UI/UX design? (website, mobile app, SaaS, dashboard)",
      "Who are the target users?",
      "Do you already have wireframes, sketches, or user flows?",
      "What are the main user actions or conversion goals?",
      "Do you need low-fidelity wireframes, high-fidelity UI, or prototypes?",
      "What design style or apps/websites do you like?",
      "Do you have brand guidelines, colors, fonts, or a design system?",
      "What is the timeline and number of screens required?",
    ],
  },
  {
    slug: "logo-design",
    name: "Logo Design",
    icon: "Badge",
    accent: "from-amber-500 to-orange-500",
    questions: [
      "What is your brand or business name?",
      "What does your business do?",
      "What feeling should the logo communicate?",
      "Do you prefer a wordmark, icon, mascot, monogram, or combination logo?",
      "What colors or styles do you like or dislike?",
      "Share 3 logo references you like.",
      "Where will the logo be used? (website, packaging, social media, print)",
      "What file formats do you need on delivery?",
    ],
  },
  {
    slug: "photography",
    name: "Photography",
    icon: "Camera",
    accent: "from-slate-500 to-gray-700",
    questions: [
      "What type of photography do you need? (product, event, portrait, real estate, food)",
      "Where will the shoot take place?",
      "How many final edited photos do you need?",
      "Do you have a mood board or visual reference?",
      "What date and time is required?",
      "Will props, models, or styling be needed?",
      "What usage rights do you require?",
      "What is your budget and delivery deadline?",
    ],
  },
  {
    slug: "illustration",
    name: "Illustration",
    icon: "Brush",
    accent: "from-pink-500 to-fuchsia-600",
    questions: [
      "What type of illustration do you need? (character, editorial, product, book, icon set)",
      "How many illustrations are required?",
      "What style are you looking for?",
      "Where will the illustrations be used?",
      "Do you have sketches, references, or a mood board?",
      "What colors or brand guidelines should be followed?",
      "Do you need source files or only final exports?",
      "What is the deadline and revision expectation?",
    ],
  },
  {
    slug: "branding",
    name: "Branding",
    icon: "Sparkles",
    accent: "from-purple-500 to-pink-600",
    questions: [
      "What is your brand name and what do you offer?",
      "Who is your ideal customer?",
      "What brand personality should we create? (premium, playful, bold, minimal, trustworthy)",
      "Do you need logo, colors, typography, brand guidelines, or full identity?",
      "Who are your competitors?",
      "What brands inspire you visually?",
      "Where will the branding be used? (website, packaging, social, print)",
      "What is your timeline and budget?",
    ],
  },
  {
    slug: "marketing-strategy",
    name: "Marketing Strategy",
    icon: "TrendingUp",
    accent: "from-green-500 to-teal-600",
    questions: [
      "What is your business goal? (leads, sales, awareness, retention)",
      "Who is your target audience?",
      "What channels are you currently using?",
      "What has worked or failed in past marketing efforts?",
      "What is your monthly marketing budget?",
      "Do you need organic, paid, email, content, or full-funnel strategy?",
      "Who are your main competitors?",
      "What timeline do you expect for measurable results?",
    ],
  },
  {
    slug: "e-commerce",
    name: "E-commerce",
    icon: "ShoppingCart",
    accent: "from-emerald-500 to-green-600",
    questions: [
      "What products do you sell?",
      "How many products or categories will be listed?",
      "Which platform do you use or prefer? (Shopify, WooCommerce, custom)",
      "Do you have product photos, descriptions, and pricing ready?",
      "Which payment and shipping methods are needed?",
      "Do you need inventory, discounts, subscriptions, or reviews?",
      "Will you sell internationally?",
      "What is your launch timeline and budget?",
    ],
  },
  {
    slug: "custom",
    name: "Custom",
    icon: "Briefcase",
    accent: "from-zinc-500 to-slate-600",
    questions: [
      "What service or project do you need help with?",
      "What is the main goal of this project?",
      "Who is the target audience or end user?",
      "What deliverables do you expect?",
      "Do you have references, examples, or files to share?",
      "What is your preferred timeline?",
      "What is your budget range?",
      "Are there any special requirements or constraints?",
    ],
  },
];

export function findNiche(slug) {
  return NICHES.find((n) => n.slug === slug) || NICHES[0];
}
